import { CcpaStatus } from "@ihr-radioedit/inferno-core";
import type { Store } from "../../../client/stores";

export function setBeacon(store: Store) {
  if (store.getCcpaStatus() === CcpaStatus.OptOut) {
    window.deferAnalyticsVendorBeacons = true;
  }
}
